import React from 'react';

interface Props {
  color?: string;
  fontSize?: number | string;
}

const Book: React.FC<Props> = ({ color = 'inherit', fontSize = 'inherit' }) => {
  return (
    <svg
      role="img"
      width="1em"
      height="1em"
      style={{ fontSize: typeof fontSize === 'string' ? fontSize : `${fontSize}px`, color }}
      viewBox="0 0 21.815 18.326"
    >
      <g id="Group_7566" data-name="Group 7566" transform="translate(0 0.751)">
        <path
          id="Library"
          d="M23.286,5.348A9.7,9.7,0,0,0,12.908,4.98a9.71,9.71,0,0,0-10.379.367L2,5.679v16.3l1.653-1.034a7.575,7.575,0,0,1,8.6-.065l.654.5.654-.5a7.579,7.579,0,0,1,8.605.061l1.648,1.034V5.679ZM8.064,17.3a9.786,9.786,0,0,0-3.882.821V6.988a7.573,7.573,0,0,1,7.635-.04V18.085a9.559,9.559,0,0,0-3.753-.78Zm13.57.821A9.507,9.507,0,0,0,14,18.083V6.948a7.573,7.573,0,0,1,7.635.04Z"
          transform="translate(-2 -4.403)"
          fill="currentColor"
        />
      </g>
    </svg>
  );
};

export default Book;
